import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ReviewsPage } from '@/features/marketing/reviews/reviews-page';
import { DEFAULT_REVIEWS_RANGE, REVIEWS_RANGES, type ReviewsRange } from '@/features/marketing/reviews/reviews-range';

type ReviewsSearch = { range?: ReviewsRange };

export const Route = createFileRoute('/_auth/$orgId/marketing/reviews')({
  // Only a non-default range lives in the URL (`?range=90d`); anything unknown falls back to 30 days.
  validateSearch: (search: Record<string, unknown>): ReviewsSearch => ({
    range:
      typeof search.range === 'string' && REVIEWS_RANGES.includes(search.range as ReviewsRange) && search.range !== DEFAULT_REVIEWS_RANGE
        ? (search.range as ReviewsRange)
        : undefined,
  }),
  component: ReviewsRoute,
});

function ReviewsRoute() {
  const { orgId } = Route.useParams();
  const { range } = Route.useSearch();
  const navigate = useNavigate({ from: '/$orgId/marketing/reviews' });

  return (
    <ReviewsPage
      routeOrgId={orgId}
      range={range ?? DEFAULT_REVIEWS_RANGE}
      onSelectRange={(next) =>
        navigate({ search: (previous) => ({ ...previous, range: next === DEFAULT_REVIEWS_RANGE ? undefined : next }) })
      }
    />
  );
}
